const Images = {
  none: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNgYAAAAAMAASsJTYQAAAAASUVORK5CYII=',
  brick: require('./brick.png'),
  rgb_circles: require('./rgb_circles.png'),
  color_wheel_shades: require('./color_wheel_shades.png'),
  color_wheel_hues: require('./color_wheel_hues.png'),
  dad: require('./dad.png'),
  droplets: require('./droplets.png'),
  greyscale: require('./greyscale.png'),
  ripples: require('./ripples.png'),
  cloud: require('./smoke.png'),
  topography: require('./topography.png'),
  city: require('./city.png'),
};

export default Images;
